import { listResponseSchema } from '@/common/api/schemas.ts';
import { z } from 'zod';

export const producerItemSchema = z.object({
  id: z.string(),
  code: z.string(),
});

export type ProducerItem = z.infer<typeof producerItemSchema>;

export const producerListResponseSchema = listResponseSchema(producerItemSchema);

export type ProducerListResponse = z.infer<typeof producerListResponseSchema>;

export interface CreateProducerData {
  code: string;
}

export interface UpdateProducerData extends CreateProducerData {
  id: string;
}
